"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTableStyles = void 0;
exports.createTableStyles = function (theme) { return ({
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        border: "1px solid " + theme.pallete.divider,
    },
    tableHover: {
        'tr:hover td': {
            background: theme.pallete.surface.background,
        },
    },
    thead: {},
    tbody: {},
    row: {},
    th: {
        textAlign: 'left',
        padding: '0.5rem 1rem',
        borderBottom: "1px solid " + theme.pallete.divider,
    },
    cell: {
        textAlign: 'left',
        padding: '0 1rem',
        height: '2.5rem',
        borderBottom: "1px solid " + theme.pallete.divider,
    },
    pointer: {
        cursor: 'pointer',
    },
}); };
//# sourceMappingURL=styles.js.map